import { Card, CardMedia } from "app/material-framework/materialComponents";
import { MaterialDialog } from "../material-lib/material-components/MaterialDialog";

export function UserGuideDialog({ open, handleClose }) {
  return (
    <MaterialDialog
      data-testid="naira-user-guide"
      open={open}
      onClose={handleClose}
      onReject={handleClose}
      title="NaiRA User Guide"
      body={
        <Card
          sx={{
            width: "100%",
            maxWidth: 720,
            borderRadius: 3,
            boxShadow: 2,
            bgcolor: "#00000008",
            border: "2px solid #E0E0E0",
            m: "0 auto",
          }}
        >
          <CardMedia
            component="iframe"
            src="https://players.brightcove.net/6290443307001/experience_6911afe939c0b7c69a9fef91/index.html"
            allow="fullscreen; geolocation; encrypted-media"
            title="NaiRA User Guide Video"
            sx={{
              width: "100%",
              aspectRatio: "16/9",
              border: "none",
              borderRadius: 2,
              minHeight: { md: 480 }
            }}
          />
        </Card>
      }
      showDialogActions={false}
    />
  );
}
